import moment from 'moment';

export const checkYearValid = (value) => {
    const inputValue = Number(value.slice(0, 4));
    if ((new Date().getFullYear() - inputValue) >= 18) {
        if ((new Date().getFullYear() - inputValue) <= 120) {
            return Promise.resolve();
        } else {
            return Promise.reject('Please enter valid year');
        }
    } else {
        return Promise.reject('You must be 18 year old or above');
    }
}

export const check150YearValid = (value, frequency, date) => {
    if (moment(date, 'MM/DD/YYYY', true).isValid()) {
        const currentDate = moment(new Date());
        const PreviousDate = moment(date);
        const years = currentDate.diff(PreviousDate, 'year');
        PreviousDate.add(years, 'years');
        const months = currentDate.diff(PreviousDate, 'months');
        PreviousDate.add(months, 'months');
        const days = currentDate.diff(PreviousDate, 'days')
        if (years < 18) {
            return Promise.reject('You must be 18 year old or above')
        }
        if (years > 120 || (years >= 120 && (days >= 1 || months >= 1))) {
            return Promise.reject('You must be under the age of 120.')
        }
        return Promise.resolve();
    }
    if (frequency === 'day') {
        if (value.length !== 2) {
            return Promise.reject('Please enter date in format DD')
        }
        if (isNaN(value) || value < 1 || value > 31) {
            return Promise.reject('Please enter valid day.');
        }
    } else if (frequency === 'month') {
        if (value.length !== 2) {
            return Promise.reject('Please enter month in format MM')
        }
        if (isNaN(value) || value < 1 || value > 12) {
            return Promise.reject('Please enter valid month');
        }
    } else if (frequency === 'year') {
        let a = value.split('/')
        if (a && a[2].length !== 4) {
            return Promise.reject('Please enter year in format YYYY')
        }
    }

}

export const checkTwoDigitValid = (value) => {
    const inputValue = Number(value.slice(0, 4));
    if (inputValue < 1 || inputValue > 12) {
        return Promise.reject('Please enter valid month');
    } else {
        return Promise.resolve();
    }
}

export const checkTwoDigitValidDay = (value) => {
    const inputValue = Number(value.slice(0, 4));
    if (inputValue < 1 || inputValue > 31) {
        return Promise.reject('Please enter valid day.');
    } else {
        return Promise.resolve();
    }
}
